angular.module('comcast.common.communication').factory('NotificationInterceptor', ['$rootScope', '$compile', '$q', '$log', '$uibModal', function ($rootScope, $compile, $q, $log, $uibModal) {
  'use strict';

  return function interceptor() {
    var intercept = this; // Values

    intercept.actionTaken = '';
    intercept.objectManipulated = ''; // Setters

    intercept.setAction = function (action) {
      intercept.actionTaken = action; // Return the parent object so we can chain

      return intercept;
    };

    intercept.setObject = function (objectManip) {
      intercept.objectManipulated = objectManip; // Return the parent object so we can chain

      return intercept;
    };

    intercept.request = function (config) {
      return config;
    };

    intercept.response = function (response) {
      if (response.config.method === 'POST') {
        intercept.createNotification(intercept.actionTaken + ' ' + intercept.objectManipulated + ' was successful', 'success');
      }

      return response;
    };

    intercept.responseError = function (rejection) {
      var displayMsg = '';

      if (typeof rejection === 'string') {
        displayMsg = rejection;
      } else {
        displayMsg = 'Server Error: ' + (rejection.message || rejection.data);
      }

      $log.error(rejection);
      var displayModal = intercept.showInfoModal;
      intercept.createNotification(intercept.actionTaken + ' ' + intercept.objectManipulated + ' failed', 'failure', function () {
        displayModal(displayMsg);
      });
      return $q.reject(rejection);
    };

    intercept.showInfoModal = function (displayMsg) {
      $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        // TODO this does not exist!
        templateUrl: 'app/components/common/notification/moreInfo-modal-template.html',
        controller: ["$uibModalInstance", "$scope", "information", function controller($uibModalInstance, $scope, information) {
          $scope.information = information;

          $scope.ok = function () {
            $uibModalInstance.close();
          };
        }],
        size: 'md',
        resolve: {
          information: function information() {
            return displayMsg;
          }
        }
      });
    };

    intercept.createNotification = function (message, type, moreInfoCallback) {
      var scope = $rootScope.$new();
      scope.title = message;
      scope.moreInfo = moreInfoCallback;
      scope.moreInfoClickHandler = moreInfoCallback;

      switch (type) {
        case 'success':
          scope.type = 'success'; //success, info, warning, danger

          scope.icon = 'fa fa-lg fa-check-circle';
          break;

        default:
        case 'info':
          scope.type = 'success'; //success, info, warning, danger

          scope.icon = 'fa fa-lg fa-info-circle'; // Increase the length of display for messages people will read

          scope.delay = 8000;
          break;

        case 'warning':
          scope.type = 'warning'; //success, info, warning, danger

          scope.icon = 'fa fa-lg fa-exclamation-triangle'; // Increase the length of display for messages people will read

          scope.delay = 8000;
          break;

        case 'failure':
          scope.type = 'danger'; //success, info, warning, danger

          scope.icon = 'fa fa-lg fa-times-circle'; // Increase the length of display for messages people will read

          scope.delay = 8000;
          break;
      }

      _generateNotification(scope);
    };

    var _generateNotification = function _generateNotification(scope) {
      var notificationElement = angular.element(document.createElement('notification-directive'));
      $compile(notificationElement)(scope);
    };
  };
}]);